module.exports = __webpack_public_path__ + "img/angle-right-solid.1c698df6.svg";